import React, { Fragment } from 'react';
import { Scale, ScaleType } from '@tonaljs/tonal';

import AbcNotation from 'components/abc-notation';
import { PageTitle } from '../components';
import { Table }  from 'react-bulma-components';
import _ from 'lodash';

export default function Scales() {
 
  return (
    <Fragment>
      <PageTitle name="Scale Definitions" description="All scales and more ..." />
  {/*     ScaleType: {major_pentatonic.aliases.join(', ')} */}
      <Table striped={true} size="fullwidth">
        <thead>
        <tr><th>Scale type</th><th>Aliases</th><th>Intervals</th></tr>
        </thead>
        <tbody>
      {      ScaleType.all()
              .map( (scaleType, index) => 
                <tr key={index}>
                  <td>{scaleType.name}</td><td>{scaleType.aliases.join(',')}</td><td>{scaleType.intervals.join(' ')}<br/>
                  {Scale.get("C4 "+scaleType.name).notes}<br/>
                  <div style={{width: 250}}><AbcNotation scientificNotes={Scale.get("C4 "+scaleType.name).notes} /></div>
                  </td>
                </tr>
              )
       }
       </tbody>
      </Table>
    </Fragment>
  );
}
